import Model from '../Model'

export default class RecalculateStatistics extends Model {
    // Set the resource route of the model
    resource() {
        return 'admin/statistics/recalculate'
    }
}
